<template>
    <div v-if="visible" id="no-connection" data-backdrop="static" data-keyboard="false">
        <a-modal :visible="true" id="no-connection-amodal" wrapClassName="vertical-center-modal" class="modal-dialog">
            <div class="supsis-offline-loader">
                <div class="logo-wrapper">
                    <svg class="logo-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 850 172" fill="none">
                        <g id="chat-bubble-1">
                            <path
                                d="M108.781 117.647C106.931 118.717 104.871 119.387 102.751 119.597L77.5709 123.697L64.1909 144.867L61.1809 126.357L44.1109 129.137C32.3909 131.047 21.3409 123.097 19.4209 111.377L9.91093 52.7374C8.02093 41.0274 15.9609 29.9874 27.6709 28.0674L86.3109 18.5274C93.0109 16.5174 100.261 18.8474 104.531 24.3974L107.461 28.0974L110.131 17.4074L109.431 16.5174C101.941 7.04741 94.8209 7.4074 84.8009 9.0374L26.1209 18.5774C9.17093 21.3574 -2.32908 37.3274 0.400924 54.2874L9.94093 112.937C12.7109 129.887 28.6909 141.387 45.6409 138.647L53.2209 137.417L58.7609 171.477L83.3809 132.517L104.271 129.117C108.331 128.697 112.191 127.117 115.371 124.557L117.931 122.677L110.041 116.957L108.761 117.687L108.781 117.647Z"
                                fill="#F16A52"
                            />
                        </g>
                        <g id="chat-bubble-2">
                            <path
                                d="M210.831 10.9775L152.361 0.487483C135.451 -2.52252 119.291 8.71749 116.241 25.6175L105.761 84.0975C102.751 101.007 113.991 117.157 130.891 120.217L138.451 121.567L132.361 155.538L168.531 126.967L189.371 130.707C191.181 131.027 193.021 131.197 194.861 131.197C209.931 131.197 222.831 120.388 225.471 105.548L235.961 47.0775C238.961 30.1775 227.721 14.0275 210.831 10.9675V10.9775ZM226.481 45.3975L216.001 103.877C214.181 114.127 205.271 121.587 194.861 121.587C193.581 121.587 192.301 121.477 191.041 121.247L165.941 116.738L146.301 132.267L149.611 113.807L132.611 110.757C120.941 108.647 113.171 97.4875 115.251 85.8075L125.731 27.3275C127.561 17.0775 136.471 9.61749 146.871 9.61749C148.151 9.61749 149.431 9.72748 150.691 9.95748L209.171 20.4375C220.841 22.5575 228.591 33.7175 226.491 45.3875L226.481 45.3975Z"
                                fill="#F16A52"
                            />
                            <path
                                d="M69.0809 100.217C55.6109 102.317 42.9909 93.1075 40.8909 79.6375L40.5309 77.3475L31.0309 78.8275L31.3909 81.1174C33.9909 97.7974 48.3409 110.107 65.2209 110.137C67.0109 110.137 68.8109 109.997 70.5809 109.727C89.2909 106.807 102.101 89.2675 99.1809 70.5575L98.8209 68.2675L89.3209 69.7475L89.6809 72.0374C91.7809 85.5074 82.5709 98.1275 69.1009 100.227H69.0809V100.217Z"
                                fill="#F16A52"
                            />
                            <path
                                d="M195.121 71.6875C192.551 85.0675 179.631 93.8475 166.241 91.3075C152.861 88.7575 144.081 75.8375 146.631 62.4575C146.631 62.4575 146.631 62.4475 146.631 62.4375L147.071 60.1575L137.621 58.3475L137.181 60.6275C133.621 79.2375 145.821 97.1975 164.421 100.758C183.021 104.318 200.981 92.1275 204.551 73.5275C204.551 73.5275 204.551 73.5075 204.551 73.4975L204.991 71.2175L195.541 69.4075L195.101 71.6875H195.121Z"
                                fill="#F16A52"
                            />
                        </g>
                        <g id="supsis-text">
                            <path
                                d="M297.151 123.278C289.141 123.278 281.721 121.618 274.911 118.308C268.101 114.998 262.621 110.298 258.481 104.218L270.221 89.9976C277.031 99.4776 286.061 104.218 297.291 104.218C301.531 104.218 305.031 103.208 307.791 101.188C310.561 99.1576 311.931 96.5276 311.931 93.3176C311.931 89.0776 308.841 85.5376 302.671 82.6776C301.941 82.3076 298.571 80.9776 292.591 78.6676C287.891 76.8276 283.891 74.9876 280.571 73.1476C269.791 66.9776 264.411 58.4976 264.411 47.7276C264.411 39.1676 267.641 32.0876 274.081 26.4576C280.621 20.7476 289.001 17.8876 299.221 17.8876C312.481 17.8876 323.671 22.4876 332.781 31.7076L321.871 46.6276C319.111 43.6776 315.681 41.3576 311.581 39.6476C307.481 37.9476 303.451 37.0976 299.491 37.0976C295.531 37.0976 292.241 37.9976 289.891 39.7876C287.541 41.5776 286.371 43.9576 286.371 46.8976C286.371 50.8576 289.131 54.2176 294.661 56.9876L304.741 61.3976C310.451 63.7976 314.591 65.5976 317.181 66.7876C328.781 72.4076 334.581 80.8776 334.581 92.2076C334.581 101.328 331.131 108.778 324.221 114.578C317.311 120.378 308.281 123.278 297.151 123.278Z"
                                fill="#46499D"
                            />
                            <path
                                d="M406.891 114.578C400.761 120.468 392.321 123.418 381.541 123.418C370.761 123.418 362.321 120.448 356.191 114.518C350.071 108.568 347.011 100.368 347.011 89.8576V46.3575H366.481V89.8576C366.481 94.6476 367.811 98.4675 370.491 101.328C373.161 104.188 376.841 105.608 381.541 105.608C386.241 105.608 389.921 104.188 392.591 101.328C395.261 98.4675 396.601 94.6576 396.601 89.8576V46.3575H416.071V89.8576C416.071 100.448 413.011 108.698 406.891 114.588V114.578Z"
                                fill="#46499D"
                            />
                            <path
                                d="M476.021 44.4076C486.611 44.4076 495.451 48.2376 502.541 55.8776C509.541 63.4276 513.041 72.7776 513.041 83.9176C513.041 95.0576 509.501 104.308 502.401 111.958C495.311 119.598 486.471 123.418 475.881 123.418C466.581 123.418 458.711 119.928 452.261 112.928V152.568H432.791V46.3576H452.121V55.6076C458.561 48.1476 466.531 44.4176 476.021 44.4176V44.4076ZM472.561 105.598C478.731 105.598 483.751 103.528 487.621 99.3876C491.491 95.2476 493.421 90.1376 493.421 84.0576C493.421 77.9776 491.491 72.8676 487.621 68.7276C483.751 64.5876 478.731 62.5176 472.561 62.5176C466.391 62.5176 461.511 64.5876 457.641 68.7276C453.771 72.8676 451.841 77.9776 451.841 84.0576C451.841 90.1376 453.771 95.2476 457.641 99.3876C461.511 103.528 466.481 105.598 472.561 105.598Z"
                                fill="#46499D"
                            />
                            <path
                                d="M551.421 123.558C538.351 123.558 527.991 118.718 520.351 109.058L530.711 96.7575C533.381 99.9875 536.581 102.538 540.311 104.418C544.041 106.308 547.781 107.248 551.561 107.248C554.511 107.248 556.971 106.568 558.951 105.178C560.931 103.798 561.921 102.058 561.921 99.9375C561.921 97.2575 560.121 95.0975 556.531 93.4475C555.431 92.9875 552.431 91.8375 547.551 89.9975C543.221 88.4275 540.001 87.0976 537.881 85.9876C529.221 81.8476 524.901 75.3475 524.901 66.5175C524.901 59.9775 527.481 54.5476 532.631 50.2176C537.701 45.9876 544.511 43.8676 553.071 43.8676C563.751 43.8676 572.551 47.4575 579.451 54.6375L569.781 67.1975C564.531 62.2275 558.781 59.7375 552.521 59.7375C550.031 59.7375 547.981 60.3675 546.371 61.6075C544.761 62.8475 543.951 64.3476 543.951 66.0976C543.951 69.2176 546.161 71.5275 550.581 72.9975C560.431 76.6775 566.461 79.1275 568.681 80.3175C577.151 84.7375 581.381 91.0875 581.381 99.3775C581.381 106.478 578.621 112.278 573.091 116.778C567.751 121.288 560.521 123.548 551.401 123.548L551.421 123.558Z"
                                fill="#46499D"
                            />
                            <path
                                d="M616.891 25.9076C616.891 29.3076 615.741 32.1676 613.441 34.4676C611.141 36.7776 608.281 37.9276 604.881 37.9276C601.481 37.9276 598.611 36.7776 596.311 34.4676C594.011 32.1676 592.861 29.3176 592.861 25.9076C592.861 22.4976 594.011 19.6976 596.311 17.4776C598.611 15.1776 601.471 14.0276 604.881 14.0276C608.291 14.0276 611.141 15.1776 613.441 17.4776C615.741 19.6976 616.891 22.4976 616.891 25.9076ZM614.541 46.3476V121.618H595.071V46.3476H614.541Z"
                                fill="#46499D"
                            />
                            <path
                                d="M657.081 123.558C644.011 123.558 633.651 118.718 626.011 109.058L636.371 96.7575C639.041 99.9875 642.241 102.538 645.971 104.418C649.701 106.308 653.441 107.248 657.221 107.248C660.171 107.248 662.631 106.568 664.611 105.178C666.591 103.798 667.581 102.058 667.581 99.9375C667.581 97.2575 665.781 95.0975 662.191 93.4475C661.091 92.9875 658.091 91.8375 653.211 89.9975C648.881 88.4275 645.661 87.0976 643.541 85.9876C634.881 81.8476 630.561 75.3475 630.561 66.5175C630.561 59.9775 633.141 54.5476 638.291 50.2176C643.361 45.9876 650.171 43.8676 658.731 43.8676C669.411 43.8676 678.211 47.4575 685.111 54.6375L675.441 67.1975C670.191 62.2275 664.441 59.7375 658.181 59.7375C655.691 59.7375 653.641 60.3675 652.031 61.6075C650.421 62.8475 649.611 64.3476 649.611 66.0976C649.611 69.2176 651.821 71.5275 656.241 72.9975C666.091 76.6775 672.121 79.1275 674.341 80.3175C682.811 84.7375 687.041 91.0875 687.041 99.3775C687.041 106.478 684.281 112.278 678.751 116.778C673.411 121.288 666.181 123.548 657.061 123.548L657.081 123.558Z"
                                fill="#46499D"
                            />
                            <path
                                d="M817.161 121.618H795.611L788.021 99.5276H752.381L744.511 121.618H723.101L762.051 19.5476H778.761L817.161 121.618ZM782.221 81.2776L770.341 47.2976L758.181 81.2776H782.221Z"
                                fill="#46499D"
                            />
                            <path
                                d="M849.211 25.9076C849.211 29.3076 848.061 32.1676 845.761 34.4676C843.461 36.7776 840.601 37.9276 837.201 37.9276C833.801 37.9276 830.931 36.7776 828.631 34.4676C826.331 32.1676 825.181 29.3176 825.181 25.9076C825.181 22.4976 826.331 19.6976 828.631 17.4776C830.931 15.1776 833.791 14.0276 837.201 14.0276C840.611 14.0276 843.461 15.1776 845.761 17.4776C848.061 19.6976 849.211 22.4976 849.211 25.9076ZM846.851 46.3476V121.618H827.381V46.3476H846.851Z"
                                fill="#46499D"
                            />
                        </g>
                    </svg>
                </div>
                
            <p class="noConnectionText">{{ $t("message.noConnection") }}</p>
                
                <div class="loading-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import moment from "moment";

export default {
    data() {
        return {
            visible: false,
            cancels: [],
        };
    },
    methods: {
        ...mapMutations({
            SET_NET_CONNECTION_STATUS: "app/SET_NET_CONNECTION_STATUS",
        }),
    },
    computed: {
        ...mapState({
            isNetConnectionStatusOnline: (state) => state.app.isNetConnectionStatusOnline,
            lastOfflineTimeStamp: (state) => state.app.lastOfflineTimeStamp,
        }),
    },
    created() {
        const onlineCB = () => this.SET_NET_CONNECTION_STATUS(true);
        window.addEventListener("online", onlineCB);
        this.cancels.push(() => window.removeEventListener("online", onlineCB));

        const offlineCB = () => this.SET_NET_CONNECTION_STATUS(false);
        window.addEventListener("offline", offlineCB);
        this.cancels.push(() => window.removeEventListener("offline", offlineCB));
    },
    beforeDestroy() {
        this.cancels.forEach((x) => x());
    },
    watch: {
        isNetConnectionStatusOnline(isOnline) {
            if (isOnline) {
                this.visible = false;
            } else {
                setTimeout(() => {
                    const diff = Date.now() - this.lastOfflineTimeStamp;
                    if (diff >= 3000) {
                        this.visible = !this.isNetConnectionStatusOnline;
                    }
                }, 5000);
            }
        },
    },
};
</script>
<style lang="scss">
#no-connection {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    z-index: 999999999999999999999 !important;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .modal-dialog {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
}

#no-connection-amodal {
    .ant-modal-content {
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
        color: #000;
        background-clip: padding-box !important;
        background-color: transparent !important;
        pointer-events: auto !important;
        position: relative;
        box-shadow: none !important;
        border: none !important;
    }

    .ant-modal-footer {
        display: none;
    }

    .ant-modal-header {
        display: none;
    }

    .ant-modal-close-x {
        display: none;
    }

    .vertical-center-modal {
        text-align: center;
        white-space: nowrap;
    }

    .vertical-center-modal:before {
        content: "";
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        width: 0;
    }

    .vertical-center-modal .ant-modal {
        display: inline-block;
        vertical-align: middle;
        top: 0;
        text-align: left;
    }
}

.supsis-offline-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
}

.logo-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.logo-svg {
    width: 300px;
    height: auto;
    filter: drop-shadow(0 10px 30px rgba(255, 255, 255, 0.3));
    animation: logoFloat 3s ease-in-out infinite;
}

/* Chat bubble animasyonları */
#chat-bubble-1 {
    animation: bubbleBounce 2s ease-in-out infinite;
    filter: drop-shadow(0 4px 12px rgba(241, 106, 82, 0.3));
}

#chat-bubble-2 {
    animation: bubbleBounce 2s ease-in-out 0.3s infinite;
    filter: drop-shadow(0 4px 12px rgba(241, 106, 82, 0.3));
}

/* Text animasyonu */
#supsis-text {
    animation: textPulse 2s ease-in-out infinite;
    filter: drop-shadow(0 2px 8px rgba(255, 255, 255, 0.2));
}

.loading-dots {
    display: flex;
    gap: 10px;
}

.dot {
    width: 14px;
    height: 14px;
    background: white;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(255, 255, 255, 0.3);
    animation: dotBounce 1.4s ease-in-out infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes logoFloat {
    0%, 100% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-10px);
    }
}

@keyframes bubbleBounce {
    0%, 100% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-8px);
    }
}

@keyframes textPulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.8;
    }
}

@keyframes dotBounce {
    0%, 80%, 100% {
        transform: scale(0.8);
        opacity: 0.5;
    }
    40% {
        transform: scale(1.2);
        opacity: 1;
    }
}

.noConnectionText {
    color: white;
    font-size: 20px;
    letter-spacing: 3px;
    font-weight: 600;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    text-align: center;
    margin: 10px 0;
    z-index: 1;
}
</style>
